import React from 'react';

export const Team: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl sm:text-3xl font-bold">Team</h1>
    </div>
  );
};
